import { jsx as t, jsxs as r } from "react/jsx-runtime";
import { WarningIcon as m } from "@systemeio/ui/icons";
import { twMerge as l } from "tailwind-merge";
import { FileItemBase as d } from "./file-item-base.mjs";
import { FieldErrorAndDescription as c } from "@systemeio/ui";
import { FileItemName as f } from "./file-item-name.mjs";
import { ReloadIcon as u } from "../../icons/reload-icon.mjs";
import { formatBytes as h } from "../../utils/format-bytes.mjs";
function F(e) {
  const n = (() => {
    if (e.error && e.onRetryAfterError)
      return /* @__PURE__ */ t(
        "div",
        {
          className: l(
            "absolute top-0 left-0 flex h-full w-full cursor-auto items-center justify-center rounded-md",
            e.disabled && "hidden"
          ),
          children: /* @__PURE__ */ t(
            "div",
            {
              onClick: e.onRetryAfterError,
              className: "cursor-pointer rounded-md bg-black/20 p-2 transition-transform hover:scale-105",
              children: /* @__PURE__ */ t(u, {})
            }
          )
        }
      );
  })(), o = e.error ? /* @__PURE__ */ t(
    c,
    {
      error: /* @__PURE__ */ r("div", { className: "flex gap-1.5", children: [
        /* @__PURE__ */ t(m, { className: "min-w-3.5 w-3.5" }),
        /* @__PURE__ */ t("span", { className: "text-left", children: e.error })
      ] })
    }
  ) : e.isLoading ? /* @__PURE__ */ t("div", { className: "bg-background-secondary max-w-36 relative h-1.5 w-full rounded-full ", children: /* @__PURE__ */ t(
    "div",
    {
      className: "bg-brand-primary absolute left-0 top-0 h-full rounded-full transition-[width] duration-300 ease-in-out",
      style: { width: `${e.progress ?? 0}%` }
    }
  ) }) : /* @__PURE__ */ t("div", { className: "h-1.5" }), i = e.file.name, a = h(e.file.size);
  return /* @__PURE__ */ r(
    "div",
    {
      className: "flex cursor-default flex-row gap-4",
      onClick: (s) => s.stopPropagation(),
      title: i,
      children: [
        /* @__PURE__ */ t(
          d,
          {
            ...e,
            showEditButton: !e.error && e.showEditButton,
            childrenFileWrapper: n,
            className: l(e.className, "min-h-16 min-w-16 h-16 w-16")
          }
        ),
        /* @__PURE__ */ r("div", { className: "flex w-full min-w-0 flex-col items-start justify-center gap-1", children: [
          /* @__PURE__ */ t(
            f,
            {
              name: i,
              className: "font-averta text-text-tertiary leading-4.5 text-sm font-normal"
            }
          ),
          /* @__PURE__ */ t(
            "div",
            {
              title: a,
              className: "font-averta text-text-tertiary leading-4.5 truncate text-sm font-normal",
              children: a
            }
          ),
          o
        ] })
      ]
    }
  );
}
export {
  F as FileItemWide
};
